module.exports = __webpack_public_path__ + "img/foto condell_thumb.412a00f0.jpg";